import { useCookie } from "react-use"

const useAuth = () => {
    const [value] = useCookie("moises:user:auth");
    const isLoggedIn = value ? true : false

    return { isLoggedIn }
}

export { useAuth }